// Small shared components of the Analyst Portfolios app. TiltBar is the Portfolio
// Viewer's / Trading app's diverging tilt bar, copied so it looks identical.
import React from 'react';

/* Diverging horizontal bar (target − SAA neutral): colour = asset-class colour;
   direction (right/left of centre) = over/under. */
export function TiltBar({ value, max, color, suffix = '% vs SAA' }) {
  const v = Number(value) || 0;
  const w = Math.min(50, (Math.abs(v) / (max || 1)) * 50);
  const over = v >= 0;
  const near = Math.abs(v) < 0.05;
  return (
    <div className="tiltbar" title={`${v >= 0 ? '+' : ''}${v.toFixed(1)}${suffix}`}>
      <span className="tiltbar-track">
        {!near && (
          <span className="tiltbar-fill"
            style={{ background: color, ...(over ? { left: '50%', width: `${w}%` } : { right: '50%', width: `${w}%` }) }} />
        )}
      </span>
      <span className={`tiltbar-num ${near ? 'flat' : ''}`}>
        {near ? '·' : `${v >= 0 ? '+' : ''}${v.toFixed(1)}`}
      </span>
    </div>
  );
}

/** The viewer's "Select Portfolio" control, for the single-book tabs. */
export function BookSelect({ id, value, onChange, books, children }) {
  return (
    <div className="chart-controls">
      <div className="chart-portfolio-selector">
        <label htmlFor={id}>Select Portfolio:</label>
        <select id={id} value={value || ''} onChange={(e) => onChange(e.target.value)}>
          {books.map((b) => <option key={b.code} value={b.code}>{b.name}</option>)}
        </select>
      </div>
      {children}
    </div>
  );
}

/** A note / warning band (mint for notes, amber edge for warnings, coral for errors). */
export function Notice({ kind = 'info', children }) {
  return <div className={`ap-notice ap-notice-${kind}`}>{children}</div>;
}

/** Two-or-more option pill toggle. */
export function Toggle({ options, value, onChange }) {
  return (
    <div className="ap-toggle" role="group">
      {options.map(([v, label]) => (
        <button key={v} type="button" className={`ap-toggle-btn${value === v ? ' on' : ''}`}
          onClick={() => onChange(v)}>{label}</button>
      ))}
    </div>
  );
}
